import { render } from "./AppAside.vue?vue&type=template&id=16bfce5c&scoped=true"
import script from "./AppAside.vue?vue&type=script&lang=js"
export * from "./AppAside.vue?vue&type=script&lang=js"

import "./AppAside.vue?vue&type=style&index=0&id=16bfce5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16bfce5c"]])

export default __exports__